import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import { Tabs, Typography, Spin, Row, Col, Input, message, Button } from 'antd'
import { Queries, Mutations } from '../../../../graphql'
import Container from '../../../../components/user/Container'
import Condition1 from './condition1'
import Condition2 from './condition2'
import Condition3 from './condition3'
import FormInputAddress from '../../../../components/user/FormInputAddress'
import TabsBlockProFile from '../../../../components/user/TabsBlockProFile'
import { datasetsProfileDetail, tabProfile } from '../../../../config/datasetsProfile'
import { checkType } from '../../../../utils/checkType'
import { pushAge } from '../../../../utils/formatdate'
import moment from 'moment'

const { TabPane } = Tabs
const { Text, Title } = Typography

class Fund extends Component {
	state = {
		showCondition: null,
		dataForm: null,
		showDataPreLoads: true,
		profile: null,
		providentFundRateHistoryIsActiveBtn: null,
		fundPolicyIsActiveBtn: null
	}

	fetchAllProvidentFundDetail =  async () =>{
		const { client, location } = this.props

		try {
			const { data, errors } = await client.query({
				query: Queries.fetchAllProvidentFundDetail,
			})


			console.log('data.fetchAllProvidentFundDetail',data.fetchAllProvidentFundDetail)

			if(data.fetchAllProvidentFundDetail){
				await this.setState({
					dataForm : data.fetchAllProvidentFundDetail,
					showCondition: data.fetchAllProvidentFundDetail.empFundStatusType,
					showDataPreLoads: false,
					providentFundRateHistoryIsActiveBtn: data.fetchAllProvidentFundDetail.providentFundRateHistory ? data.fetchAllProvidentFundDetail.providentFundRateHistory.isBtnActive ? data.fetchAllProvidentFundDetail.providentFundRateHistory.isBtnActive : false : false,
					fundPolicyIsActiveBtn: data.fetchAllProvidentFundDetail.fundPolicy ? data.fetchAllProvidentFundDetail.fundPolicy.isBtnActive ? data.fetchAllProvidentFundDetail.fundPolicy.isBtnActive : false : false,
					providentFundBenefitsPersonIsActiveBtn: data.fetchAllProvidentFundDetail.providentFundBenefitsPerson ? data.fetchAllProvidentFundDetail.providentFundBenefitsPerson.isBtnActive ? data.fetchAllProvidentFundDetail.providentFundBenefitsPerson.isBtnActive : false : false,
				})
			}else{
				await this.setState({
					showDataPreLoads: false
				})
			}
		} catch (e) {
			// message.error('Something went wrong. Please try again')
		}
	}

	fetchProfile = async () => {
		try {
			const { client } = this.props
			const { data } = await client.query({
				query: Queries.fetchProfile
			})

			if(data.fetchProfile){
				await this.setState({ 
					profile: data.fetchProfile,
				})
			}else{
				return null
			}
			
		} catch (e) {
			// message.error('Something went wrong. Please try again')
		}
	}

	async componentDidMount(){
		await this.fetchProfile()
		await this.fetchAllProvidentFundDetail()
    }

	render() {
		const { match } = this.props
		const { 
				showCondition, 
				dataForm, showDataPreLoads, 
				profile, 
				providentFundRateHistoryIsActiveBtn, 
				fundPolicyIsActiveBtn,
				providentFundBenefitsPersonIsActiveBtn
			} = this.state
		console.log('dataForm',dataForm)

		return (
			<Container match={match}>
				<div className="card-container" id="page-profile">
					<Spin spinning={showDataPreLoads}>
						{
							showCondition == 'NOTMEMBER' &&
								<Condition1 dataForm={dataForm} profile={profile}/>
						}

						{
							showCondition == 'ISMEMBER' &&
								<Condition2 
									dataForm={dataForm} 
									profile={profile}
									fundPolicyIsActiveBtn={fundPolicyIsActiveBtn}
									providentFundRateHistoryIsActiveBtn = {providentFundRateHistoryIsActiveBtn}
									providentFundBenefitsPersonIsActiveBtn = { providentFundBenefitsPersonIsActiveBtn }
									fetchAllProvidentFundDetail = {this.fetchAllProvidentFundDetail}
								/>
						}
						
						{
							showCondition == 'CANCELMEMBER' &&
								<Condition3 dataForm={dataForm} profile={profile}/>
						}
					</Spin>
				</div>
			</Container>
		)
	}
}

Fund.propTypes = {
	//
}

export default withApollo(Fund)
